import { Box, Typography, Button } from '@mui/material';

export const ExitModalContent = ({
  onDismiss,
  onExit,
}: {
  onDismiss: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onExit: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        boxShadow:
          '0px 0px 1px #EAECF0, 0px 32px 64px -12px rgba(29, 41, 57, 0.08)',
        borderRadius: '4px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: {
          xs: 326,
          md: 600,
        },
      }}
    >
      <Box className="width-full px-8 pt-8 pb-6 flex">
        <Typography variant="h4" data-testid="actionModalTitle">
          Are you sure you want to exit?
        </Typography>
      </Box>
      <Box className="width-full px-8 py-2 flex" data-testid="actionModalText">
        <Typography>You will lose the changes you have made.</Typography>
      </Box>
      <Box className="width-full px-8 pt-6 pb-8 flex justify-end gap-4">
        <Button variant="text" onClick={onExit} className="text-green-1">
          Exit
        </Button>
        <Button
          onClick={onDismiss}
          className="bg-green-1 px-4 text-white hover:text-inherit"
          data-testid="actionModalActionText"
        >
          Stay Here
        </Button>
      </Box>
    </Box>
  );
};
